<mat-dialog-content class="mat-typography" align="center">
    <p class="color-white">
        {{ "COOKIES_DIALOG.MSG" | translate }}
    </p>
</mat-dialog-content>
<mat-dialog-actions align="end" style="margin-top: -15px">
    <button mat-flat-button color="primary" [mat-dialog-close]="true" cdkFocusInitial>OK</button>
</mat-dialog-actions>
